export async function waitUntil(condition: () => boolean, timeout = 50): Promise<void> {
    while (!condition()) {
        await new Promise(f => setTimeout(f, timeout));
    }
}
